import React, { useState, useEffect, useCallback } from 'react';
import { Form, Button } from 'react-bootstrap';
import './loginForm.scss';
import { useDispatch } from 'react-redux';
import { loginAction } from '../../actions/login/loginAction';
import CaptchaService from '../../services/captchaService';
import ModalComponent from '../../components/modal/modalComponent';
import fetchOptionsAction from '../../actions/requestsActions/fetchOptionsAction';
import LogService from '../../services/logService';

const LoginForm = (props) => {
  const [captchaImg, setCaptchaImg] = useState('');
  const [token, setToken] = useState('');
  const [authData, setAuthData] = useState({ user: {} });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const [isRequieredDataLoaded, setLoaded] = useState(false);
  const [showModal, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [modal, setModalData] = useState({
    tile: '',
    message: '',
    okLabel: 'Ok',
    closeLabel: undefined,
    onOk: handleClose,
    onCancel: undefined
  });

  const handleLogin = () => {
    errors.fullName = authData.user.fullName ? '' : 'Please enter Full Name';
    errors.agency = authData.user.agency ? '' : 'Please enter Agency';
    errors.captcha = authData.user.captcha ? '' : 'Please enter Captcha';

    setErrors(() => ({ ...errors }));

    if (Object.values(errors).some(v => !!v)) {
      return;
    };

    if (!isRequieredDataLoaded) {
      setModalData({
        title: 'Error',
        message: 'The server is busy. \nPlease try again.',
        okLabel: 'Ok',
        onOk: handleClose
      });
      setShow(true);
      return;
    }

    CaptchaService.validateCaptcha(authData.user.captcha, token)
      .then(() => {
        dispatch(loginAction(authData));
        props.props.history.push('/basicInformation', { from: props.props.history.location.pathname });
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          errors.captcha = 'The captcha code has expired.';
        } else if (err?.response?.status === 400) {
          errors.captcha = 'The entered text does not match the picture.';
        }
        setErrors(() => ({ ...errors }));
      });
  };

  const myChangeHandler = useCallback((event) => {
    const key = event.target.name;
    const val = event.target.value;

    setAuthData((auth) => {
      auth.user[key] = val;
      return auth;
    });
  }, [setAuthData]);

  useEffect(() => {
    dispatch(fetchOptionsAction(undefined))
      .then(() => {
        setLoaded(true);
      });

    if (!authData.user.logConfig) {
      LogService.getConfig()
        .then((value) => {
          setAuthData((auth) => {
            auth.user.logConfig = value.data;
            return auth;
          });
        });
    }
  }, [dispatch, setLoaded, authData, setAuthData]);

  const getNewCaptcha = () => {
    CaptchaService.getCaptcha()
      .then(({ data: { value, token } }) => {
        setCaptchaImg(value);
        setToken(token);
      });
  };

  useEffect(getNewCaptcha, []);

  return (
    <div className="login-form-contrainer">
      <span className="login-title">Referral Information</span>
      <Form className="login-form">
        <Form.Group>
          <Form.Label>
            Your Full Name<span className="required">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            required
            name="fullName"
            maxLength="50"
            onChange={myChangeHandler}
            isInvalid={errors.fullName}
          />
          <Form.Control.Feedback type="invalid">
            {errors.fullName}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group>
          <Form.Label>
            Your Agency<span className="required">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            required
            name="agency"
            maxLength="50"
            onChange={myChangeHandler}
            isInvalid={errors.agency}
          />
          <Form.Control.Feedback type="invalid">
            {errors.agency}
          </Form.Control.Feedback>
        </Form.Group>
      </Form>
      <div className="login-second-ctn">
        <div className="captcha-ctn">
          <img src={captchaImg} alt="captcha" />
          <Form.Group>
            <div className="captcha-input">
              <Form.Control
                type="text"
                className="captcha-text"
                required
                name="captcha"
                placeholder="Type the text"
                autoComplete="off"
                onChange={myChangeHandler}
                maxLength="6"
                isInvalid={errors.captcha}
              />
              <Button
                type="submit"
                className="refresh btn-light"
                onClick={getNewCaptcha}
              >
                <i className="fa fa-refresh"></i>
              </Button>
              <Form.Control.Feedback type="invalid">
                {errors.captcha}
              </Form.Control.Feedback>
            </div>
          </Form.Group>
        </div>
        <div>
          <Button
            type="submit"
            className="login-btn"
            onClick={handleLogin}
          >
            Load Form
          </Button>
        </div>
      </div>
      <ModalComponent
        title={modal.title}
        message={modal.message}
        show={showModal}
        okBtn={modal.okLabel}
        closeBtn={modal.cancelLabel}
        handleOk={modal.onOk}
        handleCancel={modal.onCancel}
      ></ModalComponent>
    </div>
  );
};

export default LoginForm;
